@if (!network.isOnline()) {
<div
   class="fixed inset-0 z-[10000] flex items-center justify-center overflow-hidden bg-bg p-6">

   <!-- Ambient glow field -->
   <div class="pointer-events-none absolute inset-0">
      <div class="offline-orb offline-orb--one bg-primary/20"></div>
      <div class="offline-orb offline-orb--two bg-amber-400/20"></div>
   </div>

   <div
      class="relative z-10 flex w-full max-w-md flex-col items-center gap-7 rounded-3xl border border-border bg-surface p-10 text-center shadow-2xl">

      <!-- Signal-lost mark: broken cloud with pulsing rings -->
      <div class="relative flex h-28 w-28 items-center justify-center">
         <span class="offline-ring offline-ring--a border-primary/30"></span>
         <span class="offline-ring offline-ring--b border-primary/20"></span>

         <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
            class="relative z-10 h-16 w-16 text-primary">
            <path
               d="M20 44a10 10 0 0 1-1-19.9A14 14 0 0 1 45.5 27 9 9 0 0 1 46 44"
               stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"
               class="offline-cloud" />
            <!-- slash: the "no signal" cut -->
            <path d="M14 12 50 52" stroke="currentColor" stroke-width="3.5" stroke-linecap="round"
               class="offline-slash text-amber-500" />
         </svg>
      </div>

      <div class="flex flex-col items-center gap-2">
         <h1 class="text-2xl font-extrabold tracking-tight text-text">
            {{ 'offline.title' | translate }}
         </h1>
         <p class="max-w-xs text-sm leading-relaxed text-text-muted">
            {{ 'offline.message' | translate }}
         </p>
      </div>

      <!-- Live "waiting" indicator -->
      <div class="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.15em] text-primary/80">
         <span class="offline-dot"></span>
         <span class="offline-dot offline-dot--2"></span>
         <span class="offline-dot offline-dot--3"></span>
         <span class="ms-1">{{ 'offline.hint' | translate }}</span>
      </div>

      <button type="button" (click)="network.refresh()"
         class="mt-1 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-2.5 text-sm font-semibold text-white shadow-lg transition-transform duration-200 hover:scale-105 active:scale-95">
         <i class="pi pi-refresh"></i>
         {{ 'offline.retry' | translate }}
      </button>
   </div>
</div>
}
